// extracted by mini-css-extract-plugin
export default {"TotalAnimationDuration":"1100","AnimationDuration":"800","BodyDelayTiming":"300"};